/* jshint esversion: 6 */

/***********************************************************************
 Controller class for user depend data stored in the TTKF publisher.
 ***********************************************************************/
import {PublisherCourseDataResponseParser} from "publisher/PublisherCourseDataResponseParser";
import {RequestService} from "common/RequestService";

const keyList = [
    "cmi.core.score.raw",
    "cmi.core.lesson_status",
    "cmi.core.lesson_location"
];

const responseParser = new PublisherCourseDataResponseParser();

export function requestLearningScoDataFromPublisher( serverUrl, learningScoMap ) {

    const requestData = {
        idList: getIds( learningScoMap ),
        keyList: keyList.toString()
    };

    return new Promise( ( resolve, reject ) => {
        return RequestService.sendAsyncLmsRequest(
            `${serverUrl}/get-value-collection`,
            `id_list=${requestData.idList}&key_list=${requestData.keyList}`
        )
            .then( (response) => {

                if( response === "false" ) {
                    reject("lms communication error on publisher!" );
                    return;
                }

                const learnerData = buildResult( requestData, response );
                resolve( learnerData );
            })
            .catch( (reason) => reject( reason ) );
    });
}

function getIds( sequenceMap ) {

    if (!sequenceMap) {
        return "";
    }

    return Object.keys(sequenceMap).toString();
}

function buildResult( requestData, response) {

    if ( !requestData || !response ) {
        return new Map();
    }

    const sequenceScoIds = requestData.idList.split(","),
        scoDataCollection = responseParser.getScoArray(response);

    if( scoDataCollection.length !== sequenceScoIds.length ) {
        return new Map();
    }

    const result = new Map();
    scoDataCollection.forEach( (scoData, index) => {

        const values = responseParser.getValueArray(scoData);
        if (values.length !== keyList.length) {
            return;
        }

        result.set( sequenceScoIds[index], {
            score: values[0],
            lessonStatus: values[1],
            lessonLocation: values[2]
        });
    });

    return result;
}
